'use strict';

module.exports = '3.4.5';